var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIceCreamActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.38 5.24C14.79 2.24 12.14 0 9 0C5.86 0 3.21 2.24 2.62 5.24C1.08 5.81 0 7.29 0 9C0 11.21 1.79 13 4 13C4.12 13 4.23 12.98 4.34 12.98L9.07 22L13.68 12.97C13.79 12.98 13.89 13 14 13C16.21 13 18 11.21 18 9C18 7.29 16.92 5.81 15.38 5.24ZM9.05 17.63L6.32 12.42C7.15 12.79 8.06 13 9 13C9.95 13 10.88 12.79 11.72 12.4L9.05 17.63ZM14 11C13.48 11 12.99 10.8 12.61 10.44L12.05 9.9L11.39 10.32C10.68 10.76 9.86 11 9 11C8.14 11 7.32 10.76 6.61 10.31L5.95 9.9L5.39 10.44C5.01 10.79 4.52 11 4 11C2.9 11 2 10.11 2 9C2 8.02 2.72 7.18 3.68 7.03L4.45 6.9L4.51 6.12C4.71 3.8 6.66 2 9 2C11.34 2 13.29 3.8 13.48 6.12L13.54 6.9L14.31 7.02C15.28 7.18 16 8.01 16 9C16 10.1 15.1 11 14 11Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCreamActive);
export default __webpack_public_path__ + "static/media/IceCreamActive.826d4340de3b5440d6ca22ca6ac4a7d9.svg";
export { ForwardRef as ReactComponent };